import React from "react";
import loadingInfiniteScroll from "../../assets/icons/gif/loadingTrx.gif";
import "./style.scss";

const LoaderTrxinfinite = ({ style }) => {
  return (
    <div className="loader-infinite-container" style={style}>
      <p className="loader-infinite-container__text">Loading...</p>
      <div className="loader-infinite-container__icon">
        <img src={loadingInfiniteScroll} alt="principal-logo" />
      </div>
    </div>
  );
};

export default LoaderTrxinfinite;
